import Vue from 'vue'
import Router from 'vue-router'
import list from '../view/list'
import add from '../view/add'
import login from '../view/login'
import improveInfo from '../view/improve_info'
import forgetPassword from '../view/forgetPassword'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/list/0'
    },
    {
      path: '/list/:index',
      name: 'list',
      component: list
    },
    {
      path: '/add/:type/:index/:status/:id',
      name: 'add',
      component: add
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/improve_info',
      name: 'improveInfo',
      component: improveInfo
    },
    {
      path: '/forget_password',
      name: 'forgetPassword',
      component: forgetPassword
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js